<aside 
  [class]="'fixed inset-y-0 left-0 shadow-sm z-50 transition-all duration-300 border-r dark:border-gray-700 ' + (isOpen() ? 'w-64 translate-x-0' : 'w-16 translate-x-0')"
  [style.background-color]="'var(--card-background, #ffffff)'"
  [style.border-color]="'var(--border-color, #e5e7eb)'">
  <div class="flex flex-col h-full">
    <!-- Logo -->
    <div 
      class="flex items-center justify-center h-16 text-white transition-colors duration-200 border-b"
      [style.background]="'linear-gradient(to right, var(--theme-color-1, #2563eb), var(--theme-color-2, #1e40af))'"
      [style.border-bottom-color]="'var(--theme-color-1, #2563eb)'">
      <div class="flex items-center justify-center">
        <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
        @if (isOpen()) {
          <h1 class="text-xl font-bold transition-opacity duration-300 ml-2">Health Care</h1>
        }
      </div> 
    </div>

    <!-- Navigation -->
    <app-scrollbar
      variant="primary"
      size="thin"
      visibility="auto"
      [smoothScroll]="true"
      class="flex-1">
      <nav [class]="'py-4 space-y-1 ' + (isOpen() ? 'px-3' : 'px-2')">
        @for (item of menuItems(); track item.route) {
          <app-tooltip 
            [text]="item.label"
            position="right"
            [disabled]="isOpen()">
            <a 
              [routerLink]="item.route" 
              routerLinkActive="sidebar-link-active"
              [routerLinkActiveOptions]="item.route === '/dashboard' ? {exact: true} : {exact: false}"
              [class]="'sidebar-link ' + (isOpen() ? '' : 'justify-center')">
              <svg class="w-5 h-5 flex-shrink-0" [class]="isOpen() ? 'mr-3' : ''" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="item.icon" />
              </svg>
              @if (isOpen()) {
                <span class="transition-opacity duration-300 flex-1">{{ item.label }}</span>
              }
              @if (isOpen() && item.badge) {
                <span 
                  class="ml-auto text-xs px-2 py-0.5 rounded-full"
                  [style.background-color]="item.badgeColor ? undefined : 'color-mix(in srgb, var(--theme-color-1, #2563eb) 15%, transparent)'"
                  [style.color]="item.badgeColor ? undefined : 'var(--theme-color-1, #2563eb)'"
                  [class]="item.badgeColor || ''">
                  {{ item.badge }}
                </span>
              }
              <!-- Badge for closed sidebar - show as dot indicator -->
              @if (!isOpen() && item.badge) {
                <span 
                  class="absolute top-1 right-1 w-2 h-2 rounded-full"
                  [style.background-color]="item.badgeColor?.includes('red') ? '#ef4444' : 'var(--theme-color-1, #2563eb)'">
                </span>
              }
            </a>
          </app-tooltip>
        }
      </nav>
    </app-scrollbar>

    <!-- User Section -->
    <div 
      class="border-t transition-colors duration-200"
      [class]="isOpen() ? 'p-4' : 'p-2'"
      [style.border-color]="'var(--border-color, #e5e7eb)'"
      [style.background-color]="'var(--surface-color, #f9fafb)'">
      <div [class]="'flex items-center ' + (isOpen() ? 'mb-3' : 'justify-center')">
        <div 
          [class]="'rounded-full flex items-center justify-center text-white font-semibold shadow-md ' + (isOpen() ? 'w-10 h-10' : 'w-8 h-8')"
          [style.background]="'linear-gradient(to bottom right, var(--theme-color-1, #2563eb), var(--theme-color-2, #1e40af))'">
          {{ authService.user()?.firstName?.charAt(0) }}{{ authService.user()?.lastName?.charAt(0) }}
        </div>
        @if (isOpen()) {
          <div class="ml-3 flex-1 min-w-0">
            <p class="text-sm font-semibold text-gray-900 dark:text-gray-100 truncate">
              {{ authService.user()?.firstName }} {{ authService.user()?.lastName }}
            </p>
            <p class="text-xs text-gray-500 dark:text-gray-400 truncate">{{ authService.user()?.role }}</p>
          </div>
        }
      </div>
      <app-tooltip 
        text="Logout"
        position="right"
        [disabled]="isOpen()">
        <button 
          (click)="onLogout()" 
          [class]="'text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors duration-200 font-medium ' + (isOpen() ? 'w-full px-4 py-2 text-sm' : 'w-full p-2 flex items-center justify-center')">
          <svg class="w-4 h-4" [class]="isOpen() ? 'inline mr-2' : ''" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          @if (isOpen()) {
            <span>Logout</span>
          }
        </button>
      </app-tooltip>
    </div>
  </div>
</aside>

